export default __webpack_public_path__ + "de.fc8c64b0.svg";